var global = require('../internals/global');

module.exports = global.Promise;



//////////////////
// WEBPACK FOOTER
// /tmp/build_310c34ba/node_modules/core-js/internals/promise-native-constructor.js
// module id = 78
// module chunks = 2